import { RouteInfo } from './sidebar.metadata';
export const ROUTES: RouteInfo[] = [
    {
        path: '/components/home', title: 'Inicio', icon: 'fas fa-home text-primary', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], Conade:true, instituto:true, Coordinador: true, Promotor:true, Consulta: false
    },
    {
      path: '/components/centro-activacion', title: 'Espacio de Activación', icon: 'fas fa-map-marker-alt', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],Conade:true, instituto:false, Coordinador: true, Promotor:true, Consulta: false
    },
    {
      path: '/components/usuarios', title: 'Usuarios', icon: 'fas fa-users-cog', class: 'sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
        {
          path: '/components/usuarios/coordinador', title: 'Coordinador', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu:[],Conade:true, instituto:true, Coordinador: false, Promotor:true, Consulta: false
        },
        {
          path: '/components/usuarios/promotor', title: 'Embajador', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu:[], Conade:true, instituto:false, Coordinador: true, Promotor:false, Consulta: false
        }
      ], Conade:true, instituto:true, Coordinador: true, Promotor:false
    },
    {
      path: '/components/activacion-participantes', title: 'Activación', icon: 'fas fa-running', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],Conade:true, instituto:false, Coordinador: false, Promotor:true, Consulta: false
    },
    {
      path: '/components/evaluaciones/evaluaciones-list', title: 'Evaluaciones', icon: 'fa-solid fa-clipboard-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],Conade:false, instituto:false, Coordinador: false, Promotor:true, Consulta: false
    },
    {
      path: '/components/eventos-masivos', title: 'Actividades Masivas', icon: 'fas fa-calendar', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],Conade:true, instituto:false, Coordinador: true, Promotor:false, Consulta: true
    }
    ,
    {
      path: '/components/tableros', title: 'Tableros', icon: 'fas fa-columns', class: 'sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
        {
          path: '/components/tableros/coordinador', title: 'Coordinador', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu:[], Conade:true, instituto:true, Coordinador: false, Promotor:false, Consulta: false
        },
        {
          path: '/components/tableros/promotor', title: 'Embajador', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu:[], Conade:true, instituto:false, Coordinador: true, Promotor:true, Consulta: false
        },
        {
          path: '/components/tableros/conade', title: 'Conade', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu:[], Conade:false, instituto:false, Coordinador: false, Promotor:false, Consulta: false
        },
        {
          path: '/components/tableros/tablero-coordinador-consulta', title: 'Coordinador', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu:[], Conade:false, instituto:false, Coordinador: false, Promotor:false, Consulta: true
        },
        {
          path: '/components/tableros/tablero-embajador-consulta', title: 'Embajador', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: true, submenu:[], Conade:false, instituto:false, Coordinador: false, Promotor:false, Consulta: true
        }

      ], Conade:true, instituto:true, Coordinador: true, Promotor:true, Consulta: true
    }
];
